export default function HearingAid({ className = "" }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 48 48"
      className={className}>
      <path d="M24 0C14.5 0 6.7 7.8 6.7 17.3c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5C9.7 9.4 16.1 3 24 3s14.3 6.4 14.3 14.3c0 2.8-.8 5.6-2.4 7.9-.8 1.1-3.2 3.9-4.5 4.9-2.2 1.8-3.5 5.6-3.8 7.5-.2.8-1.6 7.4-8.6 7.4-2.4 0-4.6-.9-6.8-2.6-.6-.5-1.6-.4-2.1.2-.5.6-.4 1.6.2 2.1C13.1 46.9 16 48 19 48c7.6 0 10.8-6.2 11.5-9.8.4-2 1.5-4.7 2.8-5.7 1.9-1.5 4.9-5.3 5-5.5l.1-.1c1.9-2.9 2.9-6.2 2.9-9.6C41.3 7.8 33.5 0 24 0z" />
      <path d="M28.5 23.7c-.7.5-.8 1.4-.4 2.1.5.7 1.4.8 2.1.4 2.8-2 4.5-5.3 4.5-8.8 0-6-4.8-10.8-10.8-10.8-5.9 0-10.6 4.7-10.8 10.8v.5c-.1 2.2-.2 5.5 1.7 8.7.3.5.8.7 1.3.7.3 0 .5-.1.8-.2.7-.4.9-1.4.5-2.1-1.4-2.4-1.3-5.1-1.3-7v-.5c.1-4.4 3.6-7.9 7.8-7.9 4.3 0 7.8 3.5 7.8 7.8.1 2.4-1.1 4.8-3.2 6.3z" />
      <path d="M14.6 33.2c3.8 0 10.2 0 10.6-4.5.2-2-1.3-4.6-4.4-7.6-.6-.6-1.5-.6-2.1 0-.6.6-.6 1.5 0 2.1 2.5 2.5 3.6 4.4 3.5 5.2-.1 1.8-5.6 1.8-7.6 1.8-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5z" />
    </svg>
  )
}
